export default "__VITE_ASSET__WmthzM$___"